import React, { useState, useRef, useEffect } from 'react';
import QRSectionEditor from '../components/editor/QRSectionEditor';
import QRCodeStyling from "qr-code-styling";
import { RiResetLeftFill } from "react-icons/ri";
import { FaChevronDown, FaPlus, FaDownload, FaCopy } from "react-icons/fa";
import { MdOutlineImageNotSupported } from "react-icons/md";
import logomyH from '../assets/images/logomyH.png';
import { logoOptions } from '../components/donvi';

export default function QRDocument() {
  const [isformatStyleQR, setIsformatStyleQR] = useState(false);
  const [isformatColorQR, setIsformatColorQR] = useState(false);
  const [isformatLogoQR, setIsformatLogoQR] = useState(false);
  const [previewHTML, setPreviewHTML] = useState('');
  const fileInputRef = useRef(null);

  const valueSelectStyleQR = [
    { value: "square", label: "Vuông" },
    { value: "classy", label: "Thanh lịch" },
    { value: "classy-rounded", label: "Bo tròn thanh lịch" },
    { value: "dots", label: "Nhiều chấm" },
    { value: "dot", label: "Chấm" },
    { value: "rounded", label: "Bo tròn" },
    { value: "extra-rounded", label: "Bo tròn đặc biệt" },
  ];

  const [qrSettings, setQrSettings] = useState(() => {
    const savedSettings = localStorage.getItem("qrEditorSettings");
    return savedSettings
      ? JSON.parse(savedSettings)
      : {
          width: 300,
          height: 300,
          type: "svg",
          shape: "square",
          data: "https://example.com",
          image: logomyH,
          margin: 1,
          dotsOptionsColor: "#000000",
          dotsOptionsType: "dots",
          backgroundOptionsColor: "#ffffff",
          cornersSquareOptionsType: "extra-rounded",
          cornersSquareOptionsColor: "#000000",
          cornersDotOptionsType: "extra-rounded",
          cornersDotOptionsColor: "#000000",
          imageOptions_crossOrigin: "anonymous",
          imageOptions_margin: 1,
        };
  });
  const qrRef = useRef(null);
  const qrCode = useRef(new QRCodeStyling());

  useEffect(() => {
    updateQRCode();
  }, [qrSettings]);

  const updateQRCode = () => {
    qrCode.current.update({
      width: qrSettings.width,
      height: qrSettings.height,
      type: qrSettings.type,
      shape: qrSettings.shape,
      image: qrSettings.image,
      margin: qrSettings.margin,
      data: qrSettings.data,
      dotsOptions: { 
        color: qrSettings.dotsOptionsColor, 
        type: qrSettings.dotsOptionsType 
      },
      backgroundOptions: { 
        color: qrSettings.backgroundOptionsColor 
      },
      cornersSquareOptions: { 
        type: qrSettings.cornersSquareOptionsType, 
        color: qrSettings.cornersSquareOptionsColor 
      },
      cornersDotOptions: { 
        type: qrSettings.cornersDotOptionsType, 
        color: qrSettings.cornersDotOptionsColor 
      },
      imageOptions: { 
        crossOrigin: "anonymous", 
        margin: qrSettings.imageOptions_margin 
      },
    });
    
    if (qrRef.current) {
      qrRef.current.innerHTML = "";
      qrCode.current.append(qrRef.current);
    }
  };

  const handleQRChange = (field, value) => {
    const newSettings = { ...qrSettings, [field]: value };
    setQrSettings(newSettings);
    localStorage.setItem("qrEditorSettings", JSON.stringify(newSettings));
  };

  const handleCopyAll = (allContentText, data) => {
    if (data.htmlContent) {
      setPreviewHTML(data.htmlContent);
    }
  };

  const handleDownloadQR = async () => {
    const blob = await qrCode.current.getRawData("png");
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "QRCode.png";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadPreview = () => {
    if (!previewHTML) return;
    
    const blob = new Blob([previewHTML], { type: 'text/html' });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "QR_Preview.html";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="min-h-screen bg-gray-100 overflow-auto">
      <div className="max-w-8xl mx-auto p-4">
        <div className="grid lg:grid-cols-12 gap-4 h-[calc(100vh-120px)]">
          {/* Left Panel - QR Settings */}
          <div className="lg:col-span-3 bg-white rounded-lg shadow-sm border overflow-y-auto">
            <div className="p-4 border-b">
              <h2 className="text-lg font-semibold text-gray-700">⚙️ QR Settings</h2>
            </div>
            <div className="p-4 space-y-4">
              {/* Content Input */}
              <div>
                <label className="block text-sm font-medium mb-2 text-gray-600">Nội dung</label>
                <input
                  type="text"
                  value={qrSettings.data}
                  onChange={(e) => handleQRChange("data", e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded text-sm"
                  placeholder="Nhập nội dung..."
                />
              </div>

              {/* Logo Section */}
              <div>
                <button 
                  onClick={() => setIsformatLogoQR(!isformatLogoQR)} 
                  className="flex justify-between items-center w-full px-3 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 text-sm"
                >
                  <span>Logo QR</span>
                  <FaChevronDown className={`transition-transform duration-300 ${isformatLogoQR ? 'rotate-180' : ''}`} />
                </button>
                {isformatLogoQR && (
                  <div className="grid grid-cols-6 gap-2 p-3 mt-2 bg-gray-50 rounded">
                    {logoOptions.map((logo, index) => (
                      <button
                        key={index}
                        onClick={() => handleQRChange("image", logo)}
                        className={`
                          flex items-center justify-center aspect-square w-10 h-10 rounded border-2
                          transition-all duration-200
                          ${qrSettings.image === logo ? 'border-blue-500 ring-2 ring-blue-200' : 'border-gray-200'}
                          hover:scale-105 hover:border-blue-400 bg-white
                        `}
                      >
                        <img src={logo} alt="Logo" className="object-contain w-6 h-6" draggable={false} />
                      </button>
                    ))}
                    <button
                      onClick={() => handleQRChange("image", null)}
                      className={`
                        flex items-center justify-center aspect-square w-10 h-10 rounded border-2
                        transition-all duration-200
                        ${qrSettings.image === null ? 'border-red-500 ring-2 ring-red-200 bg-red-50' : 'border-gray-200'}
                        hover:scale-105 hover:border-red-400 bg-white
                      `}
                    >
                      <MdOutlineImageNotSupported className="text-lg text-red-500" />
                    </button>
                    <button
                      onClick={() => fileInputRef.current.click()}
                      className="flex items-center justify-center aspect-square w-10 h-10 rounded border-2 border-dashed
                        transition-all duration-200 hover:scale-105 hover:border-green-500 bg-white"
                    >
                      <FaPlus size={14} className="text-green-500" />
                    </button>
                    <input
                      type="file"
                      ref={fileInputRef}
                      accept="image/*"
                      onChange={(e) => handleQRChange("image", URL.createObjectURL(e.target.files[0]))}
                      className="hidden"
                    />
                  </div>
                )}
              </div>

              {/* Style Settings */}
              <div>
                <button 
                  onClick={() => setIsformatStyleQR(!isformatStyleQR)} 
                  className="flex justify-between items-center w-full px-3 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 text-sm"
                >
                  <span>Định dạng QR</span>
                  <FaChevronDown className={`transition-transform duration-300 ${isformatStyleQR ? 'rotate-180' : ''}`} />
                </button>
                {isformatStyleQR && (
                  <div className="space-y-3 p-3 mt-2 bg-gray-50 rounded">
                    <div>
                      <label className="block text-xs font-medium mb-1 text-gray-600">Hình dạng</label>
                      <select 
                        value={qrSettings.shape} 
                        onChange={(e) => handleQRChange("shape", e.target.value)} 
                        className="w-full p-2 border border-gray-300 rounded text-sm"
                      >
                        <option value="square">Vuông</option>
                        <option value="circle">Tròn</option>
                      </select>
                    </div>
                    
                    <div>
                      <label className="block text-xs font-medium mb-1 text-gray-600">Kiểu chấm</label>
                      <select 
                        value={qrSettings.dotsOptionsType} 
                        onChange={(e) => handleQRChange("dotsOptionsType", e.target.value)} 
                        className="w-full p-2 border border-gray-300 rounded text-sm"
                      >
                        {valueSelectStyleQR.map((item) => (
                          <option key={item.value} value={item.value}>{item.label}</option>
                        ))}
                      </select>
                    </div>

                    <div>
                      <label className="block text-xs font-medium mb-1 text-gray-600">Bo gốc</label>
                      <select 
                        value={qrSettings.cornersSquareOptionsType} 
                        onChange={(e) => handleQRChange("cornersSquareOptionsType", e.target.value)} 
                        className="w-full p-2 border border-gray-300 rounded text-sm"
                      >
                        {valueSelectStyleQR.map((item) => (
                          <option key={item.value} value={item.value}>{item.label}</option>
                        ))}
                      </select>
                    </div>

                    <div>
                      <label className="block text-xs font-medium mb-1 text-gray-600">Chấm gốc</label>
                      <select 
                        value={qrSettings.cornersDotOptionsType} 
                        onChange={(e) => handleQRChange("cornersDotOptionsType", e.target.value)} 
                        className="w-full p-2 border border-gray-300 rounded text-sm"
                      >
                        {valueSelectStyleQR.map((item) => (
                          <option key={item.value} value={item.value}>{item.label}</option>
                        ))}
                      </select>
                    </div>

                    <div>
                      <label className="block text-xs font-medium mb-1 text-gray-600">
                        Kích thước: {qrSettings.width}x{qrSettings.height}px
                      </label>
                      <input
                        type="range"
                        min="200"
                        max="500"
                        step="10"
                        value={qrSettings.width}
                        onChange={(e) => {
                          const size = parseInt(e.target.value);
                          handleQRChange("width", size);
                          handleQRChange("height", size);
                        }}
                        className="w-full"
                      />
                    </div>

                    <div>
                      <label className="block text-xs font-medium mb-1 text-gray-600">Lề logo</label>
                      <input 
                        type="number" 
                        min="0" 
                        max="20" 
                        value={qrSettings.imageOptions_margin} 
                        onChange={(e) => handleQRChange("imageOptions_margin", parseFloat(e.target.value))} 
                        className="w-full p-2 border border-gray-300 rounded text-sm"
                      />
                    </div>

                    <div>
                      <label className="block text-xs font-medium mb-1 text-gray-600">Lề QR</label>
                      <input 
                        type="number" 
                        min="0" 
                        max="20" 
                        value={qrSettings.margin} 
                        onChange={(e) => handleQRChange("margin", parseFloat(e.target.value))} 
                        className="w-full p-2 border border-gray-300 rounded text-sm"
                      />
                    </div>
                  </div>
                )}
              </div>

              {/* Color Settings */}
              <div>
                <button 
                  onClick={() => setIsformatColorQR(!isformatColorQR)} 
                  className="flex justify-between items-center w-full px-3 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 text-sm"
                >
                  <span>Định dạng màu QR</span>
                  <FaChevronDown className={`transition-transform duration-300 ${isformatColorQR ? 'rotate-180' : ''}`} />
                </button>
                {isformatColorQR && (
                  <div className="space-y-3 p-3 mt-2 bg-gray-50 rounded">
                    <div>
                      <label className="block text-xs font-medium mb-1 text-gray-600">Màu chấm</label>
                      <div className="flex gap-2">
                        <input 
                          type="color" 
                          value={qrSettings.dotsOptionsColor} 
                          onChange={(e) => handleQRChange("dotsOptionsColor", e.target.value)} 
                          className="w-12 h-8 border border-gray-300 rounded"
                        />
                        <input 
                          type="text" 
                          value={qrSettings.dotsOptionsColor} 
                          onChange={(e) => handleQRChange("dotsOptionsColor", e.target.value)} 
                          className="flex-1 p-2 border border-gray-300 rounded text-sm"
                        />
                      </div>
                    </div>

                    <div>
                      <label className="block text-xs font-medium mb-1 text-gray-600">Màu nền</label>
                      <div className="flex gap-2">
                        <input 
                          type="color" 
                          value={qrSettings.backgroundOptionsColor} 
                          onChange={(e) => handleQRChange("backgroundOptionsColor", e.target.value)} 
                          className="w-12 h-8 border border-gray-300 rounded"
                        />
                        <input 
                          type="text" 
                          value={qrSettings.backgroundOptionsColor} 
                          onChange={(e) => handleQRChange("backgroundOptionsColor", e.target.value)} 
                          className="flex-1 p-2 border border-gray-300 rounded text-sm"
                        />
                      </div>
                    </div>

                    <div>
                      <label className="block text-xs font-medium mb-1 text-gray-600">Màu bo gốc</label>
                      <div className="flex gap-2">
                        <input 
                          type="color" 
                          value={qrSettings.cornersSquareOptionsColor} 
                          onChange={(e) => handleQRChange("cornersSquareOptionsColor", e.target.value)} 
                          className="w-12 h-8 border border-gray-300 rounded"
                        />
                        <input 
                          type="text" 
                          value={qrSettings.cornersSquareOptionsColor} 
                          onChange={(e) => handleQRChange("cornersSquareOptionsColor", e.target.value)} 
                          className="flex-1 p-2 border border-gray-300 rounded text-sm"
                        />
                      </div>
                    </div>

                    <div>
                      <label className="block text-xs font-medium mb-1 text-gray-600">Màu chấm gốc</label>
                      <div className="flex gap-2">
                        <input 
                          type="color" 
                          value={qrSettings.cornersDotOptionsColor} 
                          onChange={(e) => handleQRChange("cornersDotOptionsColor", e.target.value)} 
                          className="w-12 h-8 border border-gray-300 rounded"
                        />
                        <input 
                          type="text" 
                          value={qrSettings.cornersDotOptionsColor} 
                          onChange={(e) => handleQRChange("cornersDotOptionsColor", e.target.value)} 
                          className="flex-1 p-2 border border-gray-300 rounded text-sm"
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Reset Button */}
              <div className="flex justify-end pt-4">
                <button 
                  onClick={() => {
                    localStorage.clear("qrEditorSettings"); 
                    window.location.reload();
                  }} 
                  className="px-3 py-2 bg-amber-500 hover:bg-amber-600 text-white rounded text-sm flex items-center gap-2"
                >
                  <RiResetLeftFill />
                  Reset
                </button>
              </div>
            </div>
          </div>

          {/* Center Panel - Editor */}
          <div className="lg:col-span-6 bg-white rounded-lg shadow-sm border overflow-y-auto">
            <div className="p-4 border-b">
              <h2 className="text-lg font-semibold text-gray-700">📝 Content Editor</h2>
            </div>
            
            <div className="p-4">
              <QRSectionEditor
                qrElement={<div ref={qrRef} />}
                qrRef={qrRef}
                onCopyAll={handleCopyAll}
              />
            </div>
          </div>

          {/* Right Panel - Preview */}
          <div className="lg:col-span-3 bg-white rounded-lg shadow-sm border overflow-y-auto">
            <div className="p-4 border-b">
              <h2 className="text-lg font-semibold text-gray-700">Preview</h2>
            </div>
            
            <div className="p-4">
              {previewHTML ? (
                <>
                  <div className="border rounded p-4 bg-gray-50 mb-4 max-h-96 overflow-y-auto">
                    <div 
                      dangerouslySetInnerHTML={{ __html: previewHTML }}
                      style={{ fontSize: '12px', lineHeight: '1.4' }}
                    />
                  </div>
                  
                  <div className="space-y-2">
                    <button
                      onClick={handleDownloadPreview}
                      className="w-full flex items-center justify-center gap-2 px-3 py-2 bg-green-500 text-white rounded hover:bg-green-600 text-sm"
                    >
                      <FaDownload size={12} />
                      Tải HTML
                    </button>
                    
                    <button
                      onClick={handleDownloadQR}
                      className="w-full flex items-center justify-center gap-2 px-3 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 text-sm"
                    >
                      <FaDownload size={12} />
                      Tải QR
                    </button>
                  </div>
                </>
              ) : (
                <div className="text-center text-gray-500 py-8">
                  <p className="text-sm mb-2">Chưa có nội dung để preview</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
